import {IAttributes, IAugmentedJQuery, IDirective, INgModelController, IQService, IScope} from "angular";
import {Throttle} from "../tjenester/Throttle";
import {BrukerRessurs} from "../tjenester/ressurser/BrukerRessurs";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import _ from "lodash";
import {l} from "../../types/typescriptdefinisjoner_lederplan";

export const validerPassord_asynsjekkPågår_nøkkel = 'sjekker';

export function validerPassordForInjisering() {
    return [regNavn.ng.$q, Throttle.regNavn, BrukerRessurs.regNavn, validerPassord];
}

/**
 * Validerer passord vhja brukerRes.validerPassord(..).
 *
 * Bruk: <input valider-passord="godtaInvKtr.validerPassordResultat">
 * properties godtaInvKtr.validerPassordResultat vil bli satt til resultatet av brukerRes.validerPassord(..)
 *
 * Eksponerer følgende feilkoder under NgModelController.$error:
 * too_short, too_long, insufficient_lowercase, insufficient_uppercase, insufficient_digit, insufficient_special
 *
 * Mens den asynkrone sjekke foregår (kallet til brukerRes.validerPassord(..)) vil 'sjekker' bli lagt til $error-strukturen.
 */
export function validerPassord($q: IQService, throttle: Throttle, brukerRes: BrukerRessurs): IDirective {

    return {
        restrict: "A",
        require: 'ngModel',
        scope: {
            validerPassord: "="
        },
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes, $ctrl: INgModelController) {
            const throttledValider = throttle.throttle(
                (passord: string) => {
                    brukerRes.validerPassord(passord).$promise
                        .then(resultat => håndterResultat(resultat));
                },
                1000); //maks ett kall per sekund

            let feilkoder: string[] = [];

            function håndterResultat(resultat:l.PassordValideringsresultat){
                resetTidligereRegistrerteFeil($ctrl);
                registrerFeil(resultat, $ctrl);
                $scope['validerPassord'] = resultat;
            }

            function resetTidligereRegistrerteFeil($ctrl) {
                $ctrl.$setValidity(validerPassord_asynsjekkPågår_nøkkel, true)
                feilkoder.forEach(kode => $ctrl.$setValidity(kode, true));
                feilkoder = [];
            }

            function registrerFeil(resultat, $ctrl) {
                resultat.feilkoder.forEach(kode => {
                    feilkoder.push(kode);
                    $ctrl.$setValidity(kode, false)
                });
            }

            // bruker ikke $ctrl.$asyncValidators da vi ønsker å throttle serversidevalideringskallet og det
            // spiller ikke bra med semantikken til $ctrl.$asyncValidators samt at vi valider(..) metoden
            // har behov for å sette multiple  validationErrorKey ( $asyncValidators setter bare en )
            $ctrl.$viewChangeListeners.push(() => {
                $ctrl.$setValidity(validerPassord_asynsjekkPågår_nøkkel, false) //sørger for at vi markerer feltet som ugyldig mens asynk sjekk foregår
                var passord = $ctrl.$viewValue;
                //kaller ikke asynk sjekk dersom passord er kortere enn 3 tegn
                if (_.size(passord) < 3) {
                    håndterResultat({
                        feilkoder:['too_short'],
                        gyldig:false
                    })
                    return;
                }
                throttledValider(passord);
            });
        }
    };
}
